export enum Multiplier {
    TCTMTwoX = 101,
    TCTMTenX = 102,
}
